import React, { useState, useEffect } from 'react';
import LbhTerms from './lbh_terms';
import LbhPolicy from './lbh_policy';
import LbhPolicyFr from './lbh_policy-fr';
import { FaApple, FaGooglePlay } from 'react-icons/fa';
import DownloadButton from './downloadButton';

const AboutContent = () => (
  <>
    <h2>A propos de Happy Now</h2>
    <p>Une recherche de Martin E. P. Seligman and Tracy A. Steen (University of Pennsylvania), Nansook Park (University of Rhode Island), Christopher Peterson  à montrer que prendre quelques minutes soir pour écrire 3 choses positives qui nous sont arrivées dans la journée aurait des impacts sur notre niveau de bonheur.<br />
      Alors s'il n'y a que ça pour nous rendre plus heureux ...essayons. <br />
      Biensûre qu'un papier et un crayson et hop on le fait ... avec une notification de rappel...ça marche déjà mieux, non ?<br />
      C'est une expérience à faire, on en reparle après ?</p>
    <p>Quand on écrit dans son carnet, c'est privé ... dans cette appli aussi. <br />
      Toutes les informations sont stocké sur le téléphone, pas de partage.<br />
      Donc oui, si vous changé de téléphone...vous perdez vos infos, mais pas le bénéfice d'avoir tenté l'expérience
    </p>
    <p><h5>Notes </h5>
      <ul>
        <li>ResearchGate : <a href="https://www.researchgate.net/publication/7701091_Positive_Psychology_Progress_Empirical_Validation_of_Interventions" target="_blank" rel="noopener noreferrer">Positive Psychology: Progress, Empirical Validation of Interventions</a></li>
        <li>Se Réaliser : <a href="https://se-realiser.com/3-choses-positives-par-jour/" target="_blank" rel="noopener noreferrer">3 choses positives par jour : augmentez votre bonheur !</a></li>
        <li>Wikipédia : <a href="https://fr.wikipedia.org/wiki/Pens%C3%A9e_positive" target="_blank" rel="noopener noreferrer">Pensée positive</a></li>
        <li>... on est jamais mieux servit que par soit-même, faites vos recherches, faites vous votre avis .. </li>
      </ul>
    </p>
    <h3>Screenshots</h3>
    <div className="screenshots">
      <img src="/LetBeHappier/1_home.png" alt="Happy Now Screenshot 1" />
      <img src="/LetBeHappier/2_feeling.png" alt="Happy Now Screenshot 2" />
      <img src="/LetBeHappier/3_pensees.png" alt="Happy Now Screenshot 3" />
      <img src="/LetBeHappier/4_sum.png" alt="Happy Now Screenshot 4" />
      <img src="/LetBeHappier/5_histo.png" alt="Happy Now Screenshot 5" />
    </div>
  </>
);

function HappyNow() {
  const [activeView, setActiveView] = useState('about');

  useEffect(() => {
    // On component mount, check the URL hash and set the active view accordingly.
    const hash = window.location.hash.substring(1);
    if (['about', 'terms', 'policy', 'policy-fr'].includes(hash)) {
      setActiveView(hash);
    }
  }, []); // Empty dependency array ensures this runs only once on mount.


  const handleLinkClick = (e, view) => {
    e.preventDefault();
    setActiveView(view);
    // Update the URL hash to allow for direct linking, without reloading the page.
    window.history.pushState(null, '', `#${view}`);
  };

  return (
    <div className="ddoublecam-container">
      <div className="ddoublecam-left-column">
        <h3>Happy Now : </h3>
        <div className="download-buttons">
          <DownloadButton platform="Android" link="https://play.google.com/store/apps/details?id=com.pastrycias.better.letgetbetter" Icon={FaGooglePlay} />
          <DownloadButton platform="iOS" link="https://apps.apple.com/fr/app/happy-now/id6751139746" Icon={FaApple} />
          <DownloadButton platform="Instagram" link="https://www.instagram.com/happynowtheapp/" image="/logos/instagram.svg" />
          {/*<DownloadButton platform="TikTok" link="#" image="/logos/tiktok.svg" />
          <DownloadButton platform="Youtube" link="#" image="/logos/youtube.svg" /> */}
        </div>
        <div className="legal-links">
          <a href="#about" className={activeView === 'about' ? 'active-legal-link' : ''} onClick={(e) => handleLinkClick(e, 'about')}>A propos</a>
          <a href="#terms" className={activeView === 'terms' ? 'active-legal-link' : ''} onClick={(e) => handleLinkClick(e, 'terms')}>Terms of Service</a>
          <a href="#policy" className={activeView === 'policy' ? 'active-legal-link' : ''} onClick={(e) => handleLinkClick(e, 'policy')}>Privacy Policy</a>
          <a href="#policy-fr" className={activeView === 'policy-fr' ? 'active-legal-link' : ''} onClick={(e) => handleLinkClick(e, 'policy-fr')}>Politique de confidentialité</a>
        </div>
      </div>
      <div className="ddoublecam-right-column">
        {activeView === 'about' && <AboutContent />}
        {activeView === 'terms' && <LbhTerms />}
        {activeView === 'policy' && <LbhPolicy />}
        {activeView === 'policy-fr' && <LbhPolicyFr />}
      </div>
    </div>
  );
}

export default HappyNow;
